export const env = {
  mode: import.meta.env.MODE,
  environmentId: import.meta.env.VITE_ENVIRONMENT_ID,
  appRootElementId: import.meta.env.VITE_APP_ROOT_ELEMENT_ID ?? 'root',
  masterLayoutUrl: import.meta.env.VITE_MASTER_LAYOUT_URL,
  authAuthority: import.meta.env.VITE_AUTH_AUTHORITY ?? '',
  authClientId: import.meta.env.VITE_AUTH_CLIENT_ID ?? '',
  configUrl: import.meta.env.VITE_CONFIG_URL || '/config.json',
  baseApiUrl: import.meta.env.VITE_BASE_API_URL,
  sessionCookieName: import.meta.env.VITE_SESSION_COOKIE_NAME ?? '',
  sessionCookieDomain: import.meta.env.VITE_SESSION_COOKIE_DOMAIN ?? '',
  sessionAllowedDomains: import.meta.env.VITE_SESSION_ALLOWED_DOMAINS ?? '',
} as const;
